import { FC } from 'react';
import { WbCardContent } from '@agilelab/plugin-wb-platform';
import { Paper, makeStyles } from '@material-ui/core';
import { PermissionsTable } from './PermissionsTable';

const useStyles = makeStyles(
  {
    paper: {
      height: '100%',
    },
    container: {
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
    },
    header: {
      display: 'flex',
      justifyContent: 'space-between',
    },
  },
  { name: 'PermissionsTab' },
);

export const PermissionsTab: FC = () => {
  const classes = useStyles();
  return (
    <Paper className={classes.paper}>
      <WbCardContent className={classes.container}>
        <PermissionsTable />
      </WbCardContent>
    </Paper>
  );
};
